import type { Product } from "@decocms/apps-commerce/types"
import { useId } from "react"
import ProductCard from "~/components/product/ProductCard"

interface ProductGalleryStoreProps {
    products: Product[]
    isMobile?: boolean
}

export const ProductGallery = ({ products, isMobile = false }: ProductGalleryStoreProps) => {
    const productListId = useId()

    return (
        <div
            id={productListId}
            className='relative grid h-fit grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 items-center sm:gap-8 md:gap-5 lg:gap-8'
        >
            {products.map((product, index) => (
                <ProductCard
                    key={`product-card-${product.productID}`}
                    product={product}
                    preload={index === 0}
                    isMobile={isMobile}
                    index={index}
                />
            ))}
        </div>
    )
}
